import { z } from 'zod';

export const createTunnelSchema = z.object({
  id: z.string(),
  token: z.string(),
  domain: z.string(),
});
